module.exports = __webpack_public_path__ + "img/BD_Blood_Tubes.edfe4f51.jpg";